import {
  ClientEmailGroupMode,
  IClientEmailGroup,
  IClientEmailGroupResponse,
} from '@common/interfaces/clientEmailGroup'
import Base, { Wrapped } from './base'

export interface IClientEmailGroupProvisionParams {
  mode: ClientEmailGroupMode
  /** A bare local part or a full address on the Workspace domain; omitted to retry. */
  address?: string
}

export default class ClientEmailGroups extends Base {
  get(clientId: string) {
    return this.apiClient.get(
      `client-email-groups/${clientId}`,
    ) as Wrapped<IClientEmailGroupResponse>
  }

  provision(clientId: string, data: IClientEmailGroupProvisionParams) {
    return this.apiClient.post(`client-email-groups/${clientId}`, data) as Wrapped<{
      group: IClientEmailGroup
    }>
  }

  delete(clientId: string) {
    return this.apiClient.delete(`client-email-groups/${clientId}`)
  }
}
